module.exports = __webpack_public_path__ + "img/person.302c5433.svg";